<template>
	<div class="w80pct mc">
		<Confirm
			:cancelBtn="false"
			:title="''"
			:size="'l'"
			ref="Confirm"
		></Confirm>
		<div class="tableSys mt3x mb4x">
			<div class="vaB_E dpIB_E">
				<img
					class="w15x"
					:src="
						stage.loc.logo.login[stage.languageId]
							? stage.loc.logo.login[stage.languageId]
							: stage.loc.logo.login.public
					"
				/>
				<button
					v-if="stage.setting.loc['2in1'].file"
					v-for="(item, index) in btnGroup"
					:name="index + ' ' + currentIndex"
					:key="index"
					:class="{ cSub: index != currentIndex }"
					class="fs16x ml2x pl1x"
					@click="changeBtn(index, 'currentIndex')"
				>
					{{ item.title }}
				</button>
			</div>
			<div class="taR" style="width: 65px">
				<Select
					:styleType="'noBorder'"
					:list="stage.languageList"
					:bindActive="stage.languageId"
					@Click="
						(i) => {
							setLanguage(stage.languageList[i].value);
						}
					"
				></Select>
			</div>
		</div>
		<div v-show="currentIndex == 0" class="select-content">
			<div
				class="bg-mask"
				:style="{
					'background-image': `url(${stage.setting.loc['2in1'].cover.c})`,
				}"
			>
				<div class="wrap-mask tra-fast"></div>
				<a
					class="content tra-fast"
					:href="stage.type.c"
					@click="setCookie('type', 'c')"
				>
					<h3 class="fs20x">
						{{
							$t("platformSelect1", [
								stage.loc.customerDisplay[stage.languageId] ||
									stage.loc.customerDisplay.public,
								"CSI Cloud用户版平台",
							])
						}}
					</h3>
					<p class="fs14x">
						{{
							$t("platformSelect2", [
								stage.loc.customerDisplay[stage.languageId] ||
									stage.loc.customerDisplay.public,
								"专为光伏电站用户而设计。实现光伏电站运行情况和发电收益数据的全天候监控，保障用户财产安全。",
							])
						}}
					</p>
					<div class="fs12x fWhite hover-c-white">
						{{
							$t("platformSelect3", [
								stage.loc.customerDisplay[stage.languageId] ||
									stage.loc.customerDisplay.public,
								"前往 CSI CloudPro",
							])
						}}<Icon name="more" class="ico w1x h1x ml1x" />
					</div>
				</a>
			</div>
			<div
				class="bg-mask ml1x"
				:style="{
					'background-image': `url(${stage.setting.loc['2in1'].cover.b})`,
				}"
			>
				<div class="wrap-mask tra-fast"></div>
				<a
					class="content tra-fast"
					:href="stage.type.b"
					@click="setCookie('type', 'b')"
				>
					<h3 class="fs20x">
						{{
							$t("platformSelect4", [
								stage.loc.customerDisplay[stage.languageId] ||
									stage.loc.customerDisplay.public,
								"CSI CloudPro商家版平台",
							])
						}}
					</h3>
					<p class="fs14x">
						{{
							$t("platformSelect5", [
								stage.loc.customerDisplay[stage.languageId] ||
									stage.loc.customerDisplay.public,
								"专为在电站生命周期中提供各种服务的商家而设计。我们为不同的服务内容提供了不同的业务板块来满足商家复杂的业务场景和需求，从而保障用户的电站发电收益和安全。",
							])
						}}
					</p>
					<div class="fs12x fWhite hover-c-white">
						{{
							$t("platformSelect6", [
								stage.loc.customerDisplay[stage.languageId] ||
									stage.loc.customerDisplay.public,
								"前往 CSI CloudPro",
							])
						}}<Icon name="more" class="ico w1x h1x ml1x" />
					</div>
				</a>
			</div>
		</div>
		<div
			v-show="currentIndex == 1 && stage.setting.loc['2in1'].file"
			id="downloadPanel"
		>
			<aside class="sideSys tra noSelect">
				<div class="scrollHide" scroll>
					<nav>
						<div class="menuList tra tra-fast_E">
							<a
								v-for="(item, index) in btnGroup_sideBar"
								:key="index"
								:class="{
									'cSub-imp': index != currentIndex_sideBar,
								}"
								class="fs12x"
								@click="
									changeBtn(index, 'currentIndex_sideBar')
								"
								>{{ item.title }}</a
							>
						</div>
					</nav>
				</div>
			</aside>
			<section class="downloadSection">
				<div v-show="currentIndex_sideBar == 0" class="pl2x">
					<ul class="mt3x_E">
						<li>
							<p class="fs12x">
								{{
									(stage.loc.customerDisplay[
										stage.languageId
									] || stage.loc.customerDisplay.public) +
									getLanguageStr(
										" Web+word1814",
										"CSI Cloud Web使用说明文档"
									)
								}}
							</p>
							<a
								:href="
									stage.setting.loc['2in1'].file
										? stage.setting.loc['2in1'].file.c.web[
												stage.languageId
										  ][0] +
										  '?' +
										  stage.ver
										: ''
								"
								:download="
									stage.loc.customerDisplay +
									getLanguageStr(
										' Web+word1814',
										'CSI Cloud Web使用说明文档'
									)
								"
								class="dpIB functionBtn sizeM lh25 hover-c-white"
								>{{
									getLanguageStr("cmd281", "点击这里下载")
								}}</a
							>
						</li>
						<li>
							<p class="fs12x">
								{{
									(stage.loc.customerDisplay[
										stage.languageId
									] || stage.loc.customerDisplay.public) +
									getLanguageStr(
										" APP+word1814",
										"CSI Cloud APP使用说明文档"
									)
								}}
							</p>
							<a
								:href="
									stage.setting.loc['2in1'].file
										? stage.setting.loc['2in1'].file.c.app[
												stage.languageId
										  ][0] +
										  '?' +
										  stage.ver
										: ''
								"
								:download="
									stage.loc.customerDisplay +
									getLanguageStr(
										' APP+word1814',
										'CSI Cloud APP使用说明文档'
									)
								"
								class="dpIB functionBtn sizeM lh25 hover-c-white"
								>{{
									getLanguageStr("cmd281", "点击这里下载")
								}}</a
							>
						</li>
						<li>
							<p class="fs12x">
								{{
									getLanguageStr(
										"CSI Cloud Q&A",
										"CSI Cloud Q&A"
									)
								}}
							</p>
							<a
								:href="
									stage.setting.loc['2in1'].file
										? stage.setting.loc['2in1'].file.c.qa[
												stage.languageId
										  ] +
										  '?' +
										  stage.ver
										: ''
								"
								:download="
									getLanguageStr(
										'CSI Cloud Q&A.' +
											getFileType(
												stage.setting.loc['2in1'].file.c
													.qa[stage.languageId]
											),
										'CSI Cloud Q&A'
									)
								"
								class="dpIB functionBtn sizeM lh25 hover-c-white"
								>{{
									getLanguageStr("cmd281", "点击这里下载")
								}}</a
							>
						</li>
					</ul>
				</div>
				<div v-show="currentIndex_sideBar == 1" class="pl2x">
					<ul class="mt3x_E">
						<li>
							<!-- ({{getLanguageStr('word1815','简易版')}}) +'('+getLanguageStr('word1815','简易版')+')'-->
							<p class="fs12x">
								{{
									(stage.loc.customerDisplay[
										stage.languageId
									] || stage.loc.customerDisplay.public) +
									getLanguageStr(
										"Pro Web+word1814",
										"CSI CloudPro Web使用说明文档"
									)
								}}
							</p>
							<a
								:href="
									stage.setting.loc['2in1'].file
										? stage.setting.loc['2in1'].file.b.web[
												stage.languageId
										  ][1] +
										  '?' +
										  stage.ver
										: ''
								"
								:download="
									stage.loc.customerDisplay +
									getLanguageStr(
										'Pro Web+word1814',
										'CSI CloudPro Web使用说明文档'
									)
								"
								class="dpIB functionBtn sizeM lh25 hover-c-white"
								>{{
									getLanguageStr("cmd281", "点击这里下载")
								}}</a
							>
						</li>
						<li>
							<!-- ({{getLanguageStr('word1815','简易版')}}) +'('+getLanguageStr('word1815','简易版')+')' -->
							<p class="fs12x">
								{{
									(stage.loc.customerDisplay[
										stage.languageId
									] || stage.loc.customerDisplay.public) +
									getLanguageStr(
										"Pro APP+word1814",
										"CSI CloudPro APP使用说明文档"
									)
								}}
							</p>
							<a
								:href="
									stage.setting.loc['2in1'].file
										? stage.setting.loc['2in1'].file.b.app[
												stage.languageId
										  ][1] +
										  '?' +
										  stage.ver
										: ''
								"
								:download="
									stage.loc.customerDisplay +
									getLanguageStr(
										'Pro APP+word1814',
										'CSI CloudPro APP使用说明文档'
									)
								"
								class="dpIB functionBtn sizeM lh25 hover-c-white"
								>{{
									getLanguageStr("cmd281", "点击这里下载")
								}}</a
							>
						</li>
						<li>
							<p class="fs12x">
								{{
									(stage.loc.customerDisplay[
										stage.languageId
									] || stage.loc.customerDisplay.public) +
									getLanguageStr(
										"Pro Web+word1814",
										"CSI CloudPro Web使用说明文档"
									)
								}}
								({{ getLanguageStr("word1816", "完整版") }})
							</p>
							<a
								:href="
									stage.setting.loc['2in1'].file
										? stage.setting.loc['2in1'].file.b.web[
												stage.languageId
										  ][0] +
										  '?' +
										  stage.ver
										: ''
								"
								:download="
									stage.loc.customerDisplay +
									getLanguageStr(
										'Pro Web+word1814',
										'CSI CloudPro Web使用说明文档'
									) +
									'(' +
									getLanguageStr('word1816', '完整版') +
									')'
								"
								class="dpIB functionBtn sizeM lh25 hover-c-white"
								>{{
									getLanguageStr("cmd281", "点击这里下载")
								}}</a
							>
						</li>
						<li>
							<p class="fs12x">
								{{
									(stage.loc.customerDisplay[
										stage.languageId
									] || stage.loc.customerDisplay.public) +
									getLanguageStr(
										"Pro APP+word1814",
										"CSI CloudPro APP使用说明文档"
									)
								}}
								({{ getLanguageStr("word1816", "完整版") }})
							</p>
							<a
								:href="
									stage.setting.loc['2in1'].file
										? stage.setting.loc['2in1'].file.b.app[
												stage.languageId
										  ][0] +
										  '?' +
										  stage.ver
										: ''
								"
								:download="
									stage.loc.customerDisplay +
									getLanguageStr(
										'Pro APP+word1814',
										'CSI CloudPro APP使用说明文档'
									) +
									'(' +
									getLanguageStr('word1816', '完整版') +
									')'
								"
								class="dpIB functionBtn sizeM lh25 hover-c-white"
								>{{
									getLanguageStr("cmd281", "点击这里下载")
								}}</a
							>
						</li>
						<li>
							<p class="fs12x">
								{{
									getLanguageStr(
										"CSI CloudPro Q&A",
										"CSI CloudPro Q&A"
									)
								}}
							</p>
							<a
								:href="
									stage.setting.loc['2in1'].file
										? stage.setting.loc['2in1'].file.b.qa[
												stage.languageId
										  ] +
										  '?' +
										  stage.ver
										: ''
								"
								:download="
									getLanguageStr(
										'CSI CloudPro Q&A.' +
											getFileType(
												stage.setting.loc['2in1'].file.b
													.qa[stage.languageId]
											),
										'CSI CloudPro Q&A.docx'
									)
								"
								class="dpIB functionBtn sizeM lh25 hover-c-white"
								>{{
									getLanguageStr("cmd281", "点击这里下载")
								}}</a
							>
						</li>
					</ul>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
import Select from "@/components/common/ui/Select";
import Confirm from "@/components/common/ui/Confirm";
import { setLanguage, getLanguageStr } from "@/util/language";
import * as lib from "@/util/lib.js";
export default {
	name: "PlatformSelect",
	components: { Select, Confirm },
	data() {
		return {
			stage,
			getFileType: lib.getFileType,
			currentIndex: this.$route.query.index || 0,
			currentIndex_sideBar: 0,
			btnGroup: [
				{
					title: getLanguageStr("cmd1", "首页"),
					show: true,
				},
				{
					title: getLanguageStr("word1817", "帮助"),
					show: true,
				},
				{
					title: getLanguageStr("csicloud1", "设计软件"),
					show: true,
				},
			],
			btnGroup_sideBar: [
				{
					title: "CSI Cloud",
					show: true,
				},
				{
					title: "CSI CloudPro",
					show: true,
				},
			],
		};
	},
	methods: {
		setLanguage: setLanguage,
		getLanguageStr: getLanguageStr,
		setCookie: lib.setCookie,
		changeBtn(index, currentIndex) {
			if (index == 2) {
				window.open(
					"https://webmonitoring.csisolar.com/oem/canadianSolar/download/CSIInverterStringDesktop.zip",
					"_self"
				);
				this[currentIndex] = 0;
			} else {
				this.$router.push({ path: "platformSelect", query: { index } });
				this[currentIndex] = index;
			}
		},
	},
	mounted() {
		lib.setScroll($(this.$el).find("[scroll]"));
		if (
			stage.setting.loc["2in1"].notice &&
			!lib.getCookie(stage.setting.loc["2in1"].notice.cookie)
		) {
			this.$refs.Confirm.show({
				text: stage.setting.loc["2in1"].notice[stage.languageId],
				yes: () => {
					lib.setCookie(
						stage.setting.loc["2in1"].notice.cookie,
						"pass"
					);
				},
			});
		}
	},
};
</script>
<style lang="scss" scoped>
.select-content {
	text-align: center;
}
.bg-mask {
	background-size: cover;
	background-position: center;
	width: 40%;
	min-width: 40em;
	height: 48em;
	position: relative;
	display: inline-block;
	&:hover .wrap-mask {
		opacity: 0;
	}
	&:hover .content {
		background-color: rgba($mainColor, 0.6);
	}
}
.wrap-mask {
	background: #000;
	opacity: 0.6;
	height: 100%;
	width: 100%;
	position: absolute;
	left: 0;
	bottom: 0;
}
.content {
	display: block;
	box-sizing: border-box;
	color: #fff;
	margin-left: 2em;
	margin-right: 2em;
	position: absolute;
	bottom: 2em;
	padding: {
		top: 2em;
		right: 2em;
		bottom: 6em;
		left: 2em;
	}
	text-align: left;
	min-height: 22em;
	h3 {
		margin-top: 0;
		font-weight: 400;
	}
	p {
		line-height: 1.5;
		margin-bottom: 0;
	}
	.fWhite {
		position: absolute;
		bottom: 2em;
	}
}

.lh25 {
	line-height: 2.5em;
}
#downloadPanel {
	position: absolute;
	width: 80%;
	/*height:100%;*/
	top: 10em;
	bottom: 0;
	background: #f9f9f9;
	.sideSys {
		position: absolute;
		top: 0;
		bottom: 0;
		> div {
			top: 2em;
			nav a {
				color: inherit;
				height: 3.5em;
				padding: 1em 0.5em 1em 2em;
				display: block;
				white-space: nowrap;
				position: relative;
			}
		}
	}
	.downloadSection {
		position: absolute;
		left: 17em;
		right: 0;
		top: 0;
		bottom: 0;
	}
}
</style>



// WEBPACK FOOTER //
// src/view/frame/PlatformSelect.vue